import {Trans} from 'react-i18next'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import makeStyles from '@material-ui/core/styles/makeStyles'
import messages from '../../../assets/messages'
import {config} from '../../../config'

const useStyles = makeStyles((theme) => ({
  label: {
    fontSize: '0.875rem',
    lineHeight: 1.4,
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'underline',
  },
  root: {
    // The label wraps to two lines on mobile; top-align the box with the first
    // line instead of centring it against the whole block.
    alignItems: 'flex-start',
  },
  checkbox: {
    paddingTop: 0,
  },
}))

/**
 * The PAMM Terms & Conditions PDF. `pammTermsAndConditions` is optional per
 * white-label, so fall back to the general legal documents page rather than
 * rendering a dead link.
 */
export const getPammTermsUrl = (): string =>
  config.weblinks?.pammTermsAndConditions || config.weblinks?.legalDocuments || ''

type PammTermsCheckboxProps = {
  checked: boolean
  onChange: (checked: boolean) => void
  disabled?: boolean
  id?: string
}

/**
 * Mandatory PAMM Terms & Conditions acceptance checkbox, shared by the investor
 * (offer details) and money manager (account creation) flows. The caller owns
 * the state and is responsible for keeping its submit button disabled until
 * `checked` is true — see PT-5857.
 */
export const PammTermsCheckbox = ({
  checked,
  onChange,
  disabled = false,
  id = 'pammTermsCheckbox',
}: PammTermsCheckboxProps) => {
  const classes = useStyles()

  return (
    <FormControlLabel
      classes={{label: classes.label, root: classes.root}}
      control={
        <Checkbox
          checked={checked}
          className={classes.checkbox}
          color="primary"
          disabled={disabled}
          id={id}
          inputProps={{'aria-label': 'pammTermsCheckbox'} as never}
          onChange={(e) => onChange(e.target.checked)}
        />
      }
      label={
        <Trans
          {...messages.pammTermsCheckbox}
          components={[
            <a
              className={classes.link}
              href={getPammTermsUrl()}
              rel="noreferrer noopener"
              target="_blank"
            >
              terms
            </a>,
          ]}
        />
      }
    />
  )
}
